"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ParamDictionary_1 = require("./ParamDictionary");
const globalParams = new ParamDictionary_1.default();
exports.globalParams = globalParams;
const globalParamRegexes = [];
exports.globalParamRegexes = globalParamRegexes;
const resolveParam = (key) => {
    const value = globalParams.get(key);
    if (!value) {
        for (const paramRegex of globalParamRegexes) {
            const e = paramRegex[0].exec(key);
            if (e) {
                const param = paramRegex[1](e);
                globalParams.set(param.key, param);
                break;
            }
        }
    }
    return value;
};
exports.resolveParam = resolveParam;
